/** Neutral gray used for the seat indicator dot when no zone/rgb color is available. */
const FALLBACK_DOT_COLOR = '#9B9B9B';

export default FALLBACK_DOT_COLOR;
